module.exports = __webpack_public_path__ + "img/icm-white.b1ee05ce.svg";